import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from 'react-bem-helper'

import './index.css'
const classes = new BEMHelper('heading')

export default function Heading ({ children, small, medium, spaced }) {
  return <h2 {...classes('', { small, medium, spaced })}>{children}</h2>
}

Heading.propTypes = {
  children: PropTypes.any.isRequired,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  spaced: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Heading/index.js